import { BasicInformation } from "./components/saleOperations/BasicInformation";
// import { CreateOperation } from "./components/saleOperations/CreateOperation";

export const SaleOperationsForm = () => {
  return (
    <div>
      <BasicInformation />
      {/* <CreateOperation /> */}
    </div>
  );
};
